import styled from "styled-components";
import { Column, theme } from "uikit";

const Root = styled(Column)`
	background: ${theme.colors.button_secondary};

	overflow: auto;

	${theme.scrollbar}
`;

export default Root;
